// extracted by mini-css-extract-plugin
module.exports = {"style":{"fontFamily":"'Libre Caslon Display', 'Libre Caslon Display Fallback'","fontWeight":400,"fontStyle":"normal"},"className":"__className_f21574"};